module.exports = __webpack_public_path__ + "static/media/copy-icon.d50c51b6.svg";